// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"LocalAdvertisement_adContainer__2Ev0q","landscape":"LocalAdvertisement_landscape__1mP5z","portrait":"LocalAdvertisement_portrait__34Z9t"};